interface SeoMetaProps {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  type?: string;
  image?: string;
}

export default function SeoMeta({
  title,
  description,
  keywords,
  path,
  type = 'website',
  image,
}: SeoMetaProps) {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const basePath = (__BASE_PATH__ || '/').replace(/\/$/, '');
  const canonical = `${origin}${basePath}${path}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="真相回旋镖" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      {image ? <meta property="og:image" content={image} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image ? <meta name="twitter:image" content={image} /> : null}
    </>
  );
}